import { twMerge } from "tailwind-merge";

interface SpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl" | "full";
}

const Spinner: React.FC<SpinnerProps> = ({ className, size = "full" }) => {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-8 w-8",
    xl: "h-10 w-10",
    full: "h-10 w-10",
  };

  const containerClasses =
    size === "full"
      ? "flex h-screen w-full items-center justify-center text-gray-800"
      : "inline-flex items-center justify-center text-gray-800";

  return (
    <div className={twMerge(containerClasses, className)}>
      <span className={twMerge("loading loading-spinner", sizeClasses[size])} />
    </div>
  );
};

export default Spinner;
